import Vue from "vue";
import longpress from "vue-long-press-directive";

Vue.use(longpress, { duration: 1000 });

export default longpress;
